// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`BlogPosts.vue when 4 or fewer blog posts are provided,  renders all posts 1`] = `
<section
  class="mt-4 mb-6"
>
  <h2
    class="text-EXPONDO-black text-xl mb-4 lg:text-3xl"
  >
    
    Get inspired with our blog
  
  </h2>
   
  <div
    class="grid w-full auto-rows-fr grid-cols-2 gap-x-4 gap-y-4 lg:grid-cols-4"
  >
    <div
      class=""
    >
      <blogcard-stub
        post="[object Object]"
      />
    </div>
    <div
      class=""
    >
      <blogcard-stub
        post="[object Object]"
      />
    </div>
    <div
      class=""
    >
      <blogcard-stub
        post="[object Object]"
      />
    </div>
    <div
      class=""
    >
      <blogcard-stub
        post="[object Object]"
      />
    </div>
  </div>
</section>
`;

exports[`BlogPosts.vue when more than 4 blog posts are provided,  renders only the first 4 posts 1`] = `
<section
  class="mt-4 mb-6"
>
  <h2
    class="text-EXPONDO-black text-xl mb-4 lg:text-3xl"
  >
    
    Get inspired with our blog
  
  </h2>
   
  <div
    class="grid w-full auto-rows-fr grid-cols-2 gap-x-4 gap-y-4 lg:grid-cols-4"
  >
    <div
      class=""
    >
      <blogcard-stub
        post="[object Object]"
      />
    </div>
    <div
      class=""
    >
      <blogcard-stub
        post="[object Object]"
      />
    </div>
    <div
      class=""
    >
      <blogcard-stub
        post="[object Object]"
      />
    </div>
    <div
      class=""
    >
      <blogcard-stub
        post="[object Object]"
      />
    </div>
  </div>
</section>
`;

exports[`BlogPosts.vue when showTitle is false,  renders posts without title 1`] = `
<section
  class="mt-4 mb-6"
>
  <!---->
   
  <div
    class="grid w-full auto-rows-fr grid-cols-2 gap-x-4 gap-y-4 lg:grid-cols-4"
  >
    <div
      class=""
    >
      <blogcard-stub
        post="[object Object]"
      />
    </div>
    <div
      class=""
    >
      <blogcard-stub
        post="[object Object]"
      />
    </div>
    <div
      class=""
    >
      <blogcard-stub
        post="[object Object]"
      />
    </div>
    <div
      class=""
    >
      <blogcard-stub
        post="[object Object]"
      />
    </div>
  </div>
</section>
`;
